import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 0;
`;

export const Title = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0;
`;

export const Input = styled.input`
  width: 100%;
  font-family: Rubik;
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 8px 24px;
  border: 1px solid var(--gray);
  border-radius: 8px;
  color: var(--black);
  &::placeholder {
    color: var(--gray);
  }
`;

export const ErrorMessage = styled.p`
  color: var(--red);
  padding-left: 8px;
`;

export const DownloadButton = styled.button`
  width: 100%;
  font-family: Rubik;
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 8px 24px;
  border: 1px solid var(--blue);
  background-color: var(--blue);
  font-weight: 600;
  border-radius: 8px;
  color: var(--white);
  transition: border 250ms ease, background-color 250ms ease, color 250ms ease;
  &:disabled {
    border: 1px solid var(--lwhite);
    background-color: var(--lwhite);
    color: var(--gray);
  }
`;
